import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PageShell } from "@/components/layout/PageShell";

const JOBS = [
  { title: "Senior Backend Engineer", team: "Platform", location: "Remote", type: "Full-time" },
  { title: "ML Engineer — Agent Evaluation", team: "Benchmarks", location: "Remote", type: "Full-time" },
  { title: "Frontend Engineer", team: "Product", location: "Remote", type: "Full-time" },
  { title: "Developer Advocate", team: "Community", location: "Remote", type: "Full-time" },
  { title: "QA Engineer (Dogfood)", team: "Quality", location: "Remote", type: "Full-time" },
];

export default function CareersPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Company</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Careers</h1>
          <p className="mt-4 text-base font-mono text-zinc-500 max-w-xl">
            We're building the future of QA. Join us and help shape how software gets tested.
          </p>
        </motion.div>

        <div className="mt-12 space-y-3">
          {JOBS.map((job, i) => (
            <motion.div
              key={job.title}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              data-testid={`career-listing-${i}`}
              className="group flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-5 bg-arena-surface border border-white/[0.06] rounded-md hover:border-white/[0.12] transition-colors cursor-pointer"
            >
              <div>
                <h3 className="font-heading font-semibold text-white text-base group-hover:text-arena-blue transition-colors">{job.title}</h3>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs font-mono text-zinc-500">{job.team}</span>
                  <span className="text-zinc-700">·</span>
                  <span className="text-xs font-mono text-zinc-500">{job.location}</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Badge variant="outline" className="font-mono text-[10px] text-zinc-500 border-white/[0.08]">{job.type}</Badge>
                <ArrowRight className="w-4 h-4 text-zinc-600 group-hover:text-zinc-300 transition-colors" />
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }} className="mt-12 p-8 bg-arena-surface border border-white/[0.06] rounded-md text-center">
          <p className="text-sm font-mono text-zinc-500 mb-4">Don't see a role that fits? We're always looking for talented people.</p>
          <Button data-testid="careers-general-btn" variant="outline" className="font-mono text-sm border-white/[0.08] text-zinc-400 hover:text-white hover:border-white/[0.15]">
            Send a General Application
          </Button>
        </motion.div>
      </div>
    </PageShell>
  );
}
